import axios, { AxiosResponse } from "axios";
import { IItem, IReturnItem } from "../types/IItem";
import { ISearch } from "../types/ISearch";
import { ISettings } from "../types/ISettings";
import { IMenu } from "../types/IMenu";
import { IReceipt } from "../types/IReceipt";
import { IReceiptData } from "../types/IReceiptData";
import { IProduct } from "../types/IProduct";
import { IExtra } from "../types/IExtra";
import { IVariation } from "../types/IVariation";
import { IInstruction } from "../types/IInstruction";
import { IOption } from "../types/IOption";
import { INewProduct } from "../types/INewProduct";
import { INewOption } from "../types/INewOption";
import { IInstructionCopier } from "../types/IInstructionCopier";
import { apiUrl } from "./API";
import { IAdmin } from "../types/IAdmin";
import { ISnookerTable } from "../types/ISnookerTable";
import { ISnookerAction } from "../types/ISnookerAction";

const baseConfig = {
  baseURL: apiUrl,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer ",
  },
  validateStatus: () => true,
};

export const getSettings = (token: string): Promise<ISettings | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .get("Settings", config)
    .then((response: AxiosResponse<ISettings>) => {
      return response.data;
    })
    .catch(handleError);
};

export const createOrder = (
  data: IReceiptData,
  token: string
): Promise<number | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .post("Receipt/Add", data, config)
    .then((response: AxiosResponse<number>) => {
      return response.data;
    })
    .catch(handleError);
};

// product
export const storeProduct = (
  product: IProduct,
  token: string
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .post("Product/Add", product, config)
    .then((response: AxiosResponse<boolean>) => {
      return response.data;
    })
    .catch(handleError);
};
export const updateProduct = (
  product: IProduct,
  token: string
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .post("Product/Update", product, config)
    .then((response: AxiosResponse<boolean>) => {
      return response.data;
    })
    .catch(handleError);
};
export const deleteProduct = (
  product: IProduct,
  token: string
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .post("Product/Delete", product, config)
    .then((response: AxiosResponse<boolean>) => {
      return response.data;
    })
    .catch(handleError);
};

// extras
export const storeExtra = (
  extra: IExtra,
  token: string
): Promise<number | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .post("Extra/Add", extra, config)
    .then((response: AxiosResponse<number>) => {
      return response.data;
    })
    .catch(handleError);
};

// Variation
export const storeVariation = (
  data: IVariation,
  token: string
): Promise<number | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .post("Variation/Add", data, config)
    .then((response: AxiosResponse<number>) => {
      return response.data;
    })
    .catch(handleError);
};

export const deleteVariation = (
  data: IVariation,
  token: string
): Promise<number | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .post("Variation/Delete", data, config)
    .then((response: AxiosResponse<number>) => {
      return response.data;
    })
    .catch(handleError);
};

// Instruction
export const storeInstruction = (
  data: IInstruction,
  token: string
): Promise<number | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .post("Instruction/Add", data, config)
    .then((response: AxiosResponse<number>) => {
      return response.data;
    })
    .catch(handleError);
};

export const updateInstruction = (
  data: IInstruction,
  token: string
): Promise<number | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .post("Instruction/Add", data, config)
    .then((response: AxiosResponse<number>) => {
      return response.data;
    })
    .catch(handleError);
};

export const deleteInstruction = (
  data: number,
  token: string
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .post("Instruction/Delete", data, config)
    .then((response: AxiosResponse<boolean>) => {
      return response.data;
    })
    .catch(handleError);
};

export const copyProductInstruction = (
  data: IInstructionCopier,
  token: string
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .post("Instruction/CopyInstructions", data, config)
    .then((response: AxiosResponse<boolean>) => {
      return response.data;
    })
    .catch(handleError);
};

//add multiple instructions
export const addInstruction = (
  instructions: IInstruction[],
  productId: number,
  token: string
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;

  const data = {
    instructions: instructions,
    id: productId,
  };

  return axios
    .post("Instruction/Multi", data, config)
    .then((response: AxiosResponse<boolean>) => {
      return response.data;
    })
    .catch(handleError);
};

// Options
export const storeOption = (
  data: INewOption,
  token: string
): Promise<number | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .post("Option/Add", data, config)
    .then((response: AxiosResponse<number>) => {
      return response.data;
    })
    .catch(handleError);
};
export const deleteOption = (
  op: IOption,
  token: string
): Promise<number | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .post("Option/Delete", op, config)
    .then((response: AxiosResponse<number>) => {
      return response.data;
    })
    .catch(handleError);
};

export const getReceipts = (
  startDate: Date,
  endDate: Date,
  token: string
): Promise<IAdmin | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  const dateRange = {
    start: startDate,
    end: endDate,
  };

  return axios
    .post("Admin/Dashboard", dateRange, config)
    .then((response: AxiosResponse<IAdmin>) => {
      return response.data;
    })
    .catch(handleError);
};

export const deleteReceipt = (
  id: number,
  token: string
): Promise<IAdmin | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;

  return axios
    .post("Admin/DeleteReceipt", id, config)
    .then((response: AxiosResponse<IAdmin>) => {
      return response.data;
    })
    .catch(handleError);
};

//Snooker tables
export const getSnookerTables = (
  token: string
): Promise<ISnookerTable[] | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;
  return axios
    .get("Snooker/Tables", config)
    .then((response: AxiosResponse<ISnookerTable[]>) => {
      return response.data;
    })
    .catch(handleError);
};

export const deleteSnookerTables = (
  token: string,
  uuid: string
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;

  const action: ISnookerAction = {
    uuid: uuid,
    action: "delete snooker table",
    data: "",
  };
  return axios
    .post("Snooker/Delete", action, config)
    .then((response: AxiosResponse<boolean>) => {
      if (response.status === 200) {
        return response.data;
      }
      return false;
    })
    .catch(handleError);
};

export const addSnookerTable = (
  token: string,
  table: ISnookerTable
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;

  return axios
    .post("Snooker/Add", table, config)
    .then((response: AxiosResponse<boolean>) => {
      if (response.status === 200) {
        return response.data;
      }
      return false;
    })
    .catch(handleError);
};

export const updateSnookerTable = (
  token: string,
  table: ISnookerTable
): Promise<boolean | void> => {
  const config = baseConfig;
  config.headers.Authorization = "Bearer " + token;

  return axios
    .post("Snooker/Update", table, config)
    .then((response: AxiosResponse<boolean>) => {
      if (response.status === 200) {
        return response.data;
      }
      return false;
    })
    .catch(handleError);
};

function handleError(error: any) {
  console.log("api error @ " + new Date());
  console.log(error);
  console.log(error.response);

  if (error.response) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
  } else if (error.request) {
    console.log(error.request);
  } else {
    console.log("Error", error.message);
  }
}
